const img = require('./Right Hand Outswing.svg'); export default img;